import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { insightsPlugin } from '@spotify/backstage-plugin-insights';

export const insightsModule = createFrontendModule({
  pluginId: 'backstage-insights',
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/insights',
        noHeader: true,
        routeRef: insightsPlugin.routes.root,
        loader: () =>
          import('@spotify/backstage-plugin-insights').then(m => (
            <m.InsightsPage />
          )),
      },
    }),
  ],
});
